import * as yup from "yup";
import { omanVatRule } from "./omanVatValidation";
import { OMN_COUNTRY_CODE } from "../constants/defaults";

export const BusinessProfileValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is required")
    .max(100, "Name cannot exceed 100 characters"),

  party_name: yup
    .string()
    .required("Business name is required")
    .max(150, "Business name cannot exceed 150 characters"),

  party_name_in_local_language: yup
    .string()
    .nullable()
    .max(150, "Local language name cannot exceed 150 characters"),

  email: yup
    .string()
    .required("Email is required")
    .email("Enter a valid email"),

  telephone: yup
    .string()
    .required("Telephone is required")
    .matches(/^[0-9+\-() ]*$/, "Invalid phone number format"),

  postal_address: yup.object().shape({
    street_name: yup.string().required("Street name is required"),

    additional_street_name: yup
      .string()
      .required("Additional street name is required"),

    city_name: yup.string().required("City is required"),

    address_line: yup.string().required("Address line is required"),

    postal_zone: yup
      .string()
      .required("Postal code is required")
      .matches(/^[A-Za-z0-9\- ]+$/, "Invalid postal code"),

    country_code: yup.object().required("Country is required"),

    country_subentity: yup.mixed().when("country_code", ([country_code]) => {
      if (country_code?.code === OMN_COUNTRY_CODE) {
        return yup
          .object()
          .shape({
            code: yup.string().required("Country subdivision is required"),
            name: yup.string().required(),
          })
          .required("Country subdivision is required");
      }

      return yup.string().required("Country subentity is required");
    }),
  }),

  party_tax_scheme: yup.object().when("postal_address.country_code", {
    is: (country) => country?.code === OMN_COUNTRY_CODE,
    then: () =>
      yup.object().shape({
        company_id: omanVatRule(yup.string()),
      }),
    otherwise: () => yup.object().nullable(),
  }),

    tax_scheme: yup.string().when("party_tax_scheme",
        {
            is: value => value.tax_scheme !== undefined,
            then: schema => schema.nullable(),
            otherwise: schema => schema.required("Tax scheme is required"),
        }),

  scheme_agency_id: yup.mixed().when("postal_address.country_code", {
    is: (country) => country?.code === OMN_COUNTRY_CODE,
    then: () =>
      yup.object().required("Registration type is required").nullable(),
    otherwise: () => yup.mixed().nullable(),
  }),

  company_id: yup
    .string()
    .when(["scheme_agency_id", "postal_address.country_code"], {
      is: (scheme, country) => {
        if (scheme) {
          return true;
        }
        return country?.code === OMN_COUNTRY_CODE;
      },
      then: (schema) => schema.required("Registration number is required"),
      otherwise: (schema) => schema.nullable(),
    }),

  tax_identifier: yup.string().nullable(),

  passport_issuing_country_code: yup
    .object()
    .nullable()
    .when("scheme_agency_id", {
      is: (val) => val?.code === "PASNUM",
      then: (schema) => schema.required("Passport issuing country is required"),
      otherwise: (schema) => schema.nullable(),
    }),

  endpoint_scheme_id: yup.object().required("Endpoint scheme id is required"),
  endpoint_id: yup.string().required("Endpoint id is required"),

  declaration: yup.boolean().when("requires_declaration", {
    is: true,
    then: (schema) => schema.oneOf([true], "You must accept the declaration"),
  }),

    third_party: yup.object().when("requires_third_party", {
            is: true,
            then: (schema) => schema.shape({
                name: yup.string().required("Name is required"),
                vat_identifier: yup.string().required("Vat identifier is required"),
                tax_scheme_code: yup.string().required("Tax scheme is required"),
                postal_address: yup.object().shape({
                    street_name: yup.string().required("Street name is required"),
                    city_name: yup.string().required("City is required"),
                    country_code: yup.object().required("Country is required"),
                    country_subentity: yup.object().required("Country subentity is required"),
                    postal_zone: yup.string().required("Postal zone is required"),
                }).required("Postal address is required"),
            }),
            otherwise: (schema) => schema.nullable(),
        }),
});